export default __webpack_public_path__ + "static/media/firstVisit.72ee4a3b.png";